var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSave(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.66667 3C5.53312 3 5.37548 3.05905 5.23799 3.21486C5.09694 3.37472 5 3.61554 5 3.88889V17.1111C5 17.3845 5.09694 17.6253 5.23799 17.7851C5.37548 17.941 5.53312 18 5.66667 18H17.3333C17.4669 18 17.6245 17.941 17.762 17.7851C17.9031 17.6253 18 17.3845 18 17.1111V7.10033L14.3821 3H5.66667ZM3.73832 1.89162C4.22595 1.33897 4.91615 1 5.66667 1H14.8333C15.1202 1 15.3933 1.12324 15.5832 1.33838L19.7498 6.0606C19.911 6.2433 20 6.47857 20 6.72222V17.1111C20 17.8397 19.7458 18.5598 19.2617 19.1084C18.774 19.661 18.0838 20 17.3333 20H5.66667C4.91615 20 4.22595 19.661 3.73832 19.1084C3.25425 18.5598 3 17.8397 3 17.1111V3.88889C3 3.16031 3.25425 2.44023 3.73832 1.89162Z",
    fill: "#A793F6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 11C6 10.4477 6.44772 10 7 10H16C16.5523 10 17 10.4477 17 11V19C17 19.5523 16.5523 20 16 20C15.4477 20 15 19.5523 15 19V12H8V19C8 19.5523 7.55228 20 7 20C6.44772 20 6 19.5523 6 19V11Z",
    fill: "#A793F6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 1C7.55228 1 8 1.44772 8 2V6H14C14.5523 6 15 6.44772 15 7C15 7.55228 14.5523 8 14 8H7C6.44772 8 6 7.55228 6 7V2C6 1.44772 6.44772 1 7 1Z",
    fill: "#A793F6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSave);
export default __webpack_public_path__ + "static/media/save.2e55863b149d5abcabc4e4812f2e7cbd.svg";
export { ForwardRef as ReactComponent };